import type { FaireProductEntity } from "../../entity_types/product";

export const p_vx8pdqtwm9: FaireProductEntity = {
  token: "p_vx8pdqtwm9",
  type: "product",
  name: "Classic Latte (8oz x 12pk)",
  brandToken: "b_8em2suwmrj",
  brandName: "Laurel's Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/9c8316ac58a5ef5ac2045549936d7715e2cfdd9618a0b935877908fb696145fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4429255262508d81d988dce63f6b6a8862fed56e7eb04a24be0282c2a19c861.jpeg",
  ],
  priceDollars: 30,
  description:
    "Vanilla Extract + Organic Cane Sugar + Gut-Friendly A2 dairy. A fan favorite.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:12.772Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
